import React from "react";

export default class Spinner extends React.Component {
  render() {
    const { className } = this.props;
    return (
      <div
        className={`w-full h-dvh flex justify-center items-center ${className}`}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
}
